import { useAiSubScreenContext } from 'contexts/AiScreenContext';

import type { IAiSubScreenContext } from 'utils/interfaces/IAiScreenContext';

/**
 * Declares a sub-screen from outside it, for as long as this element is mounted.
 *
 * @see [12.6 Declare a sub-screen](../../../docs/mockups/ai-agents/ai-chat/ATT-144_AI_Chat_Assistant.md)
 *
 * For a panel that stays mounted and is merely shown or hidden by a flag its parent holds: the
 * parent renders this next to it while the flag is on. A component that is itself the sub-screen
 * calls `useAiSubScreenContext` instead.
 */
function AiSubScreen({ name, url, customData }: IAiSubScreenContext): null {
  useAiSubScreenContext({ name, url, customData });

  return null;
}

export default AiSubScreen;
